module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "centerp"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("poses of the yogi")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "rightp1"
  }, [_c('img', {
    staticClass: "middle",
    attrs: {
      "alt": "Image",
      "src": "images/f0015-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "rightp"
  }, [_c('span', {
    staticClass: "txbfit"
  }, [_vm._v("Padmasana")])])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "rightp1"
  }, [_c('img', {
    staticClass: "middle",
    attrs: {
      "alt": "Image",
      "src": "images/f0015-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "rightp"
  }, [_c('span', {
    staticClass: "txbfit"
  }, [_vm._v("Anjali & Namaste Mudras")])])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "rightp1"
  }, [_c('img', {
    staticClass: "middle",
    attrs: {
      "alt": "Image",
      "src": "images/f0015-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "rightp"
  }, [_c('span', {
    staticClass: "txbfit"
  }, [_vm._v("Chakrasana")])])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "rightp1"
  }, [_c('img', {
    staticClass: "middle",
    attrs: {
      "alt": "Image",
      "src": "images/f0015-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "rightp"
  }, [_c('span', {
    staticClass: "txbfit"
  }, [_vm._v("Trikonasana")])])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "rightp1"
  }, [_c('img', {
    staticClass: "middle",
    attrs: {
      "alt": "Image",
      "src": "images/f0015-05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "rightp"
  }, [_c('span', {
    staticClass: "txbfit"
  }, [_vm._v("Siddhasana")])])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "rightp1"
  }, [_c('img', {
    staticClass: "middle",
    attrs: {
      "alt": "Image",
      "src": "images/f0015-06.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "rightp"
  }, [_c('span', {
    staticClass: "txbfit"
  }, [_vm._v("Dhanurasana")])])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "rightp1"
  }, [_c('img', {
    staticClass: "middle",
    attrs: {
      "alt": "Image",
      "src": "images/f0015-07.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "rightp"
  }, [_c('span', {
    staticClass: "txbfit"
  }, [_vm._v("Balasana")])])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "rightp1"
  }, [_c('img', {
    staticClass: "middle",
    attrs: {
      "alt": "Image",
      "src": "images/f0015-08.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "rightp"
  }, [_c('span', {
    staticClass: "txbfit"
  }, [_vm._v("Dandasana")])])])]), _c('p', {
    staticClass: "noindent5"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('span', {
    staticClass: "stickup"
  }, [_vm._v("S")]), _c('span', {
    staticClass: "fontt"
  }, [_vm._v("IMPLY PUT, YOGIS EMBODY THE")]), _vm._v(" world. Using their bodies as tools, yogis put themselves into certain positions in order to understand the workings of the world around them. By doing so, they gain empathy, compassion, and sensitivity—qualities that contribute to a more elevated state of mind, known as "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("chitta prasadanam")]), _vm._v(" in yogic scripture.")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The literal meaning of the Sanskrit word "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("yoga")]), _vm._v(" is “yoking” or “connecting.” One way of describing the state of yoga is as a feeling of interconnectedness, in which we experience that a part of us exists in everything and vice versa. To understand this more fully, we try to resemble everything we know in the universe through our asana practice. This exploration can be likened to a story about King Arthur. As a young prince, Arthur thought that the most enjoyable part of becoming king would be to rule over his kingdom. The wizard Merlin decided that Arthur would benefit from a powerful lesson. He changed the boy into different people, animals, and objects found within his kingdom, such as a peasant, a fish, a tree, the water, and a rock, so that Prince Arthur could understand what it was actually like to "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("be")]), _vm._v(" those different beings and things. Arthur’s experiences gave him the much-needed ability to put himself in others’ shoes. He began to understand that the most important job of being king is not to rule, but to serve.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Asana practice has a similar goal. We take the shape of the tree, the fish, the warrior, the turtle, and the sage so that we can begin to understand their essential natures. We can literally feel the wisdom of the sage and the stability of the tree. We can feel the power of the warrior and the steadfastness of the turtle. As a result, we experience ourselves as more deeply connected with all of life around us. Through asana practice we can feel that our body is a microcosm of the universe.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("The yogi is ready and willing to embody all states of existence, including ones that usually repulse mere mortals, such as snakes, scorpions, and even death. Through yoga, we come to know the other as ourselves and ourselves as the other. The practice allows us the opportunity to dissolve the separation born from ego, along with the fear, cynicism, and isolation that sometimes go along with daily life. Feeling joy in coming to know the world, the journey of the yogi begins.")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "imagea"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/com-02.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e32aa114","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part01.vue
// module id = 72
// module chunks = 0